module.exports = __webpack_public_path__ + "static/media/share_twitter.5633e958.webp";